import React from 'react'
import { Button } from 'hhsoig-design-system-core'

export const ProtectedDisclosureWarning = () => {
  return (
    <div>
      <h2>You may not be a protected whistleblower</h2>
      <p>
        In order to qualify for whistleblower protections, you must have
        reported fraud, gross waste of funds, abuse of authority, gross
        mismanagement, substantial and specific danger to public health and
        safety, or a violation of law, rule or regulation.
      </p>
      <Button
        variation="primary"
        data-testid="return-to-hhs-tips"
        href="https://oig.hhs.gov/fraud/report-fraud/index.asp"
      >
        Return to HHS-OIG Hotline
      </Button>
      <h4>If you wish to proceed</h4>
      <p>
        By selecting Acknowledge and continue, you acknowledge that you have
        read and understood that based on your selection, you may not be a
        protected whistleblower under HHS-OIG's jurisdiction.
      </p>
    </div>
  )
}
